import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormControlDirective, FormControlName } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { NgwWowService } from 'ngx-wow';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ROUTES } from './core/constants/routes';
import { AuthService } from './core/services/auth/auth.service';
import { DataSharingService } from './core/services/data-sharing/data-sharing.service';

const originFormControlNgOnChanges = FormControlDirective.prototype.ngOnChanges;
FormControlDirective.prototype.ngOnChanges = function () {
  this.form.accessor = this.valueAccessor;
  return originFormControlNgOnChanges.apply(this, arguments);
};

const originFormControlNameNgOnChanges = FormControlName.prototype.ngOnChanges;
FormControlName.prototype.ngOnChanges = function () {
  const result = originFormControlNameNgOnChanges.apply(this, arguments);
  this.control.accessor = this.valueAccessor;
  return result;
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewChecked, OnDestroy {
  subRoute: string;
  private _subscription = new Subscription();

  constructor(
    private router: Router,
    private wowService: NgwWowService,
    private dataSharingService: DataSharingService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
  ) {}

  @HostListener('window:message', ['$event'])
  onMessage(event) {
    const origin = event?.origin;
    if (origin !== environment.subweb_url) {
      return;
    }
    const userToken = event?.data?.model?.token;
    if (userToken) {
      this.authService.loginFromSubWeb(userToken);
    }
  }

  ngOnInit(): void {
    this.listenRouteChange();
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  listenRouteChange(): void {
    this._subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url !== event.urlAfterRedirects) {
          this.wowService.init({ offset: 15 });
        }

        this.setRouteTitle();
      }
    });
  }

  setRouteTitle(): void {
    const splittedRoute = this.router.url.split('/');

    if (splittedRoute[1] === '') {
      this.dataSharingService.currentRoute$.next(ROUTES.LOGIN);
      return;
    }

    const lastSubRoute = splittedRoute[splittedRoute.length - 1];
    const secondLastSubRoute = splittedRoute[splittedRoute.length - 2];
    let currentRoute;
    let routeFoundInSecondLast;

    const routeFoundInlast = Object.entries(ROUTES).find(([_, val]) => val.PATH === lastSubRoute);
    currentRoute = routeFoundInlast ? routeFoundInlast[1] : ROUTES.NOT_FOUND;

    if (currentRoute === ROUTES.NOT_FOUND && splittedRoute.length > 1) {
      routeFoundInSecondLast = Object.entries(ROUTES).find(
        ([_, val]) => val.PATH === secondLastSubRoute,
      );
      currentRoute = routeFoundInSecondLast ? routeFoundInSecondLast[1] : ROUTES.NOT_FOUND;
    }

    this.dataSharingService.currentRoute$.next(currentRoute);
  }
}
